// Model.js
// -----------------------
// @module Case
define("Videos.Collection",
    [
        "Backbone",
        "Backbone.CachedCollection",
        "Utils"
    ],
    function (
        Backbone,
        BackboneCachedCollection,
        Utils
    ) {
        "use strict";

        // @class Case.Fields.Model @extends Backbone.Model
        return BackboneCachedCollection.extend({

            url: Utils.getAbsoluteUrl(
                getExtensionAssetsPath('services/Videos.Service.ss')
            )
            , parse: function (response) {
                var resArr = [];

                //remove unnecessary data and return only the videoId
                //which we need for the iframe
                for (var idx = 0; idx < response.length; idx++) {
                    var videosArr = [];

                    for (var idx2 = 0; idx2 < response[idx].items.length; idx2++) {
                        var videos = response[idx].items;

                        videosArr.push({
                            id: videos[idx2].snippet.resourceId.videoId
                        });
                    }

                    resArr.push({
                        playlist: response[idx].channelName
                        , videos: videosArr
                    });
                }

                return resArr;
            }
        });
    });
